import { lazy } from 'react'

export const CheatingVariant1 = lazy(() => import('./CheatingVariant1'))
export const CheatingVariant2 = lazy(() => import('./CheatingVariant2'))
